/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ResponsiveComponent } from '../../../utils/functions';
import TableColumnSearch from '../../../components/Input/TableColumnSearch';
import Sidebar from '../../../components/Sidebar';
import { CustomTable } from '../../../components/Table';
import { plusicon, refreshicon } from '../../../components/imagepath';
import Header from '../../../components/Header';
import {
  ActionDeleteMedicine,
  ActionGetMedicineList,
} from '../../../store/Actions/MasterDataAction';
import { matchPermissions } from '../../../utils/Permission';
import { PERMISSIONS } from '../../../constants';

const { confirm } = Modal;

const Medicine = () => {
  const { loader, medicine } = useSelector(state => state?.MasterData);
  const { userDetails } = useSelector(state => state?.auth);
  const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const [IsSearching, setIsSearching] = useState(false);
  const pageSize = 10;
  const dispatch = useDispatch();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const Size = ResponsiveComponent();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [SearchList, setSearchList] = useState([]);
  const mergedArrow = useMemo(() => {
    if (arrowAtCenter)
      return {
        pointAtCenter: true,
      };
    return showArrow;
  }, [showArrow, arrowAtCenter]);
  const handleSearch = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys?.[0]);
    setSearchedColumn(dataIndex);

    if (params[dataIndex]) {
      window.location.replace(`/medicine?page=1&filterlist=true&${dataIndex}=${selectedKeys?.[0]}`);
    } else {
      window.location.replace(`/medicine?${location.search}&${dataIndex}=${selectedKeys?.[0]}`);
    }
  };
  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
    window.location.replace(`/medicine`);
  };
  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEDICINE.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEDICINE.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEDICINE.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.MEDICINE.CREATE);

  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?.id)}>
          Edit
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );
  const column = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      // key: "Sr",
      render: (text, record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Name',
      dataIndex: 'docs.name',
      render: (text, record) => <span>{record.name}</span>,
      ...TableColumnSearch({
        dataIndex: 'docs.name',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
      }),
    },

    {
      title: !canUpdate && !canDelete ? null : 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text, record, num) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover
              placement="left"
              title={record.title}
              content={() => content(record)}
              arrow={mergedArrow}
            >
              <Button type="dashed">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];
  // const OrderIndex = params?.orderIndex ? `&orderIndex=${params?.orderIndex}` : ''
  // const Title = params?.title ? `&title=${params?.title}` : ''
  // const Final = OrderIndex + Title || ''

  useEffect(() => {
    dispatch(ActionGetMedicineList({ Query: `?page=${params?.page || 1}` }));
    setRefresh(false);
  }, [dispatch, params?.page, Refresh]);

  const handleSearch1 = searchTerm => {
    var newp = params;
    newp.page = searchTerm;
    window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
  };

  const EditList = searchTerm => {
    window.location.href = `/medicine/add-medicine?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.id}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteMedicine('/' + item?.id, Res => {
            if (Res === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/medicine">Medicine</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Medicine List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Medicine List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCerate && (
                                    <Link
                                      to="/medicine/add-medicine"
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}

                                  <Link
                                    onClick={() => window.location.reload()}
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}
                      {canView ? (
                        <CustomTable
                          CurrentPageNum={parseInt(params?.page) || 1}
                          OnChange={v => {
                            handleSearch1(v);
                          }}
                          TotalPageList={medicine?.totalDocs}
                          column={column}
                          dataSource={medicine?.docs}
                          dataSourceLength={medicine?.docs?.length}
                          pageSize={10}
                          loader={loader}
                          ShowHeader={true}
                          Header={<div className="staff-search-table"></div>}
                          key={'hi'}
                        />
                      ) : (
                        <div className="permission-denied-message">
                          You do not have permission to view the medicine list.
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Medicine;
